import React, { useState, useEffect } from "react";
import { AsideMenu, DepositCard, DepositTerms } from "./DepositElements";
import style from "styled-components";
import logoSafetyPay from "../../assets/images/safetypay.png";
import { useWrapperDeposit } from '../../hooks/useWrapper';
import { useSelector } from "react-redux";
import { selectCurrency, selectId, selectUser, selectTipo } from "../../features/user/userSlice";
import { API_URL } from "../../const/api";
import axios from "axios";
import astropayLogo from '../../assets/images/LOGOASTROPAY.svg';
import transferenciaLogo from '../../assets/images/logos/TRANSFERENCIA.svg';
import pagoEfectivoLogo from '../../assets/images/logos/PAGO_EFECTIVO_01.svg';
import pay4funLogo from '../../assets/images/logos/PAY4FUN-01.svg';
import totalpagoLogo from '../../assets/images/logos/TOTAL-PAGO-01.svg';
import payretailerLogo from '../../assets/images/logos/PAY-RETAILERS.svg';
import tupayLogo from '../../assets/images/logos/TUPAY.svg';
import visa from '../../assets/images/VISA-18.svg';
import mastercard from '../../assets/images/MASTERCARD-17.svg';
import Bbva from '../../assets/images/BBVA-02.svg';
import scotia from '../../assets/images/SCOTIABANK-06.svg';
import interbank from '../../assets/images/INTERBANK-05.svg';
import bcp from '../../assets/images/BCP.svg';
import plim from '../../assets/images/PLIM-04.svg';
import wester from '../../assets/images/WESTERUNION-07.svg';
import yape from '../../assets/images/YAPE-03.svg';
import yape2 from '../../assets/images/YAPE.svg';
import Rtupay from '../../assets/images/RECARGACONTUPAY.svg';
import pagoefect from '../../assets/images/RECARGACONPAGOEFECTIVO.svg';
import pix from '../../assets/images/PIX-30.svg';
import brasilB from '../../assets/images/BANCODOBRASIL.svg';
import santander from '../../assets/images/SANTANDER-34.svg';
import caixa from '../../assets/images/CAIXA-33.svg';
import bradesco from '../../assets/images/BRADESCO-32.svg';
import boleto from '../../assets/images/BOLETO.svg';
import payfourfun from '../../assets/images/RECARGACONPAY4FUN.svg';
import pichincha from '../../assets/images/BANCOPICHINCHA.svg';
import guayaquil from '../../assets/images/BANCOGUAYAQUIL.svg';
import facilito from '../../assets/images/FACILITO-23.svg';
import Bbarrio from '../../assets/images/BANCODELBARRIO.svg';
import mivecino from '../../assets/images/MIVECINO.svg';
import Rnuvei from '../../assets/images/RECARGACONNUVEI.svg';
import Rastro from '../../assets/images/RECARGACONASTROPAY.svg';
import totalpago2 from '../../assets/images/totalpagoPasarela.svg';
import bnc from '../../assets/images/BNC-01.svg';
import bfc from '../../assets/images/bfc.svg';
import bdv from '../../assets/images/bancodevenezuela.svg';
import Rtotalpago from '../../assets/images/RECARGACONTOTALPAGO.svg';
import Ragentes from '../../assets/images/RECARGACONAGENTES.svg';
import PFprincipal from '../../assets/images/LOGO-PAGOEFECTIVO-PRINCIPAL.png';
import Rmonnet from '../../assets/images/RECARGACONMONNET.svg';
import otros from '../../assets/images/OTROS BANCOS.svg';
import amazonas from '../../assets/images/BANCOAMAZONAS.svg';
import BEstado from '../../assets/images/BANCOESTADO.svg';
import BChile from '../../assets/images/BANCODECHILE.svg';
import BFalabella from '../../assets/images/BANCOFALABELLA.svg';
import ripley from '../../assets/images/BANCORIPLEY.svg';
import redactiva from '../../assets/images/REDACTIVA.svg';
import tigomoney from '../../assets/images/BILLETERATIGOMONEY.svg';
import Rpagofacil from '../../assets/images/RECARGACONPAGOFACIL.svg';
import soli from '../../assets/images/BILLETERASOLI.svg';
import bisa from '../../assets/images/BANCOBISA.svg';
import santacruz from '../../assets/images/BANCOSANTACRUZ.svg';
import qr from '../../assets/images/QR.svg';
import simple from '../../assets/images/SIMPLEBOLIVIA.svg';
import bnb from '../../assets/images/BNB.svg';
import logoqr from '../../assets/images/LOGOQR.svg';
import coinspaid from '../../assets/images/ALPHAPO.svg';
import Rcoinspaid from '../../assets/images/RECARGA CON ALPHAPO-01.svg';
import usdt from '../../assets/images/BINANCEPAY.svg';
import Rbetterbro from '../../assets/images/RECARGACONBETTERBRO.svg';
import spei from '../../assets/images/SPEI.svg';
import galicia from '../../assets/images/BANCOGALICIA1.svg';
import nacion from '../../assets/images/BANCONACION.svg';
import city from '../../assets/images/CITYBANK.svg';
import btc from '../../assets/images/BITCOIN-01.svg';
import tether from '../../assets/images/TETHER-01.svg';
import Ralps from '../../assets/images/RECARGACONVALPS.svg';
import deuna from '../../assets/images/deunalogo.svg';
import BNC from '../../assets/images/BNC-01.svg';
import Rkushki from '../../assets/images/RECARGACONKUSHKI.svg';
import Retkushki from '../../assets/images/RETIRACONKUSHKI.svg';
import Mbank from '../../assets/images/MIBANCO.svg';
import RMibank from '../../assets/images/RECARGACONR4.svg';
import star from '../../assets/icons/star.svg';
import webpay from '../../assets/images/webpay.svg';
import mach from '../../assets/images/mach3.png';
import express from '../../assets/images/Express.svg';
import lider from '../../assets/images/Lider.svg';
import acuenta from '../../assets/images/ACUENTA.svg';
import oxxo from '../../assets/images/OXXO.svg';
import kasnet from '../../assets/images/kasnet.svg';
import niubiz from '../../assets/images/niubiz.svg';
import bcpagente from '../../assets/images/bcpagente1.svg';
import r4venezuela from '../../assets/images/R4VENEZUELA.svg';
import pagomovil from '../../assets/images/pagomovil.svg';
import continental from '../../assets/images/G&TContinental.svg';
import bam from '../../assets/images/BAM.svg';
import cajadesarrollo from '../../assets/images/CAJADEDESARROLLO.svg';
import fundaciongenesis from '../../assets/images/FUNDACIONGENESIS.svg';
import super24 from '../../assets/images/SUPER24.svg';
import akisi from '../../assets/images/AKISI.svg';
import bancoantigua from '../../assets/images/BANCODEANTIGUA.svg';
import itau from '../../assets/images/itau.svg';
import Bcolombia from '../../assets/images/BANCOLOMBIA.svg';
import nequi from '../../assets/images/NEQUI.svg';
import daviplata from '../../assets/images/DAVIPLATA.svg';
import efecty from '../../assets/images/EFECTY.svg';
import rapipago from '../../assets/images/RAPIPAGO.svg';
import qrars from '../../assets/images/QRARS.svg';
import familiarPYG from '../../assets/images/BANCOFAMILIARPARAGUAY.svg';
import atlasPYG from '../../assets/images/BANCOATLASPARAGUAY.svg';
import continentalPYG from '../../assets/images/BANCOCONTINENTALPARAGUAY.svg';
import visionPYG from '../../assets/images/VISIONPARAGUAY.svg';
import Rebdv from '../../assets/images/RECARGACONBDV.svg';

import { useTranslation } from "react-i18next";

const FormWrapper = ({ handleActiveDepositMethod, selected, actPayRetailer }) => {
  const id_uo = useSelector(selectId);
  const moneda = useSelector(selectCurrency);

  const [t] = useTranslation('global');

  const user = useSelector(selectUser);
  const tipo = useSelector(selectTipo);
  const [actPagoEfectivo, setActPagoEfectivo] = useState(false);
  const [actRetail, setActRetail] = useState(false); //brasil pay4fun
  const [actTotalP, setActTotalP] = useState(false); //bs
  const [actTotalPBFC, setActTotalPBFC] = useState(false); //bs
  const [actSafeP, setActSafeP] = useState(false);  // test3
  const [actAstro, setActAstro] = useState(false);  // todos
  const [actDeposit, setActDeposit] = useState(false);
  const [actTuPay, setActTuPay] = useState(false);
  const [actNuvei, setActNuvei] = useState(false); //NUVEI
  const [actMonnetChileTarjeta, setActMonnetChileTarjeta] = useState(false); //Monnetchile
  const [actMonnetChileBancos, setActMonnetChileBancos] = useState(false); //Monnetchile
  const [actMonnetEcuadorTarjeta, setActMonnetEcuadorTarjeta] = useState(false); //Monnetecuador
  const [actMonnetEcuadorBancos, setActMonnetEcuadorBancos] = useState(false); //Monnetecuador
  const [actMonnetPeruYape, setActMonnetPeruYape] = useState(false); //Monnetperu
  const [actMonnetPeru, setActMonnetPeru] = useState(false); //Monnetperu
  const [actPFtigomoney, setActPFtigomoney] = useState(false); //tigomoney
  const [actPFyape, setActPFyape] = useState(false); //yape
  const [actPFqr, setActPFqr] = useState(false); //QR
  const [actCoinspaid, setActCoinspaid] = useState(false); //Coinspaid
  const [actBinanceDolar, setActBinanceDolar] = useState(false); //binancepay
  const [actSpei, setActSpei] = useState(false); //Spei
  const [actBetterArs, setActBetterArs] = useState(false); //betterbro argentina
  const [actPix, setActPix] = useState(false); //betterbro pix
  const [actBoleto, setActBoleto] = useState(false); //betterbro Boleto
  const [actBinanceBRL, setActBinanceBRL] = useState(false); //binance otros
  const [actBinanceOtroMXN, setActBinanceOtroMXN] = useState(false); //binance otros
  const [actBinanceOtroARG, setActBinanceOtroARG] = useState(false); //binance otros
  const [actBinanceOtroCOP, setActBinanceOtroCOP] = useState(false); //binance otros
  const [actBinanceOtroCLP, setActBinanceOtroCLP] = useState(false); //binance otros
  const [actBinanceOtroDOP, setActBinanceOtroDOP] = useState(false); //binance otros
  const [actBinanceOtroVES, setActBinanceOtroVES] = useState(false); //binance otros
  const [actBinanceOtroBOB, setActBinanceOtroBOB] = useState(false); //binance otros
  const [actBinanceOtroEUR, setActBinanceOtroEUR] = useState(false); //binance otros
  const [actAlpsECU, setActALpsECU] = useState(false); //ALPS ecuador
  const [actAlpsPEN, setActALpsPEN] = useState(false); //ALPS peru
  const [actDeuna, setActDeuna] = useState(false); //Deuna
  const [actTotalPBNC, setActTotalPBNC] = useState(false); //bs
  const [actKushkiTransPEN, setActKushkiTransPEN] = useState(false); //kushki peru transferencia
  const [actKushkiEfectPEN, setActKushkiEfectPEN] = useState(false); //kushki peru efectivo
  const [actKushkiCardPEN, setActKushkiCardPEN] = useState(false); //kushki peru efectivo
  const [actKushkiTransECU, setActKushkiTransECU] = useState(false); //kushki peru transferencia
  const [actKushkiEfectECU, setActKushkiEfectECU] = useState(false); //kushki peru efectivo
  const [actKushkiCardECU, setActKushkiCardECU] = useState(false); //kushki peru efectivo
  const [actMiBanco, setActMibanco] = useState(false); //mi banco
  const [actPFqrbisa, setActPFqrbisa] = useState(false); //QR BISA
  const [actPFqrMercantil, setActPFqrMercantil] = useState(false); //QR MERCANTIL
  const [actAlpsEfectivoCHL, setActALpsEfectivoCHL] = useState(false); //ALPS efectivo chile
  const [actAlpsTarjetaCHL, setActALpsTarjetaCHL] = useState(false); //ALPS tarjeta chile
  const [actAlpsTransfCHL, setActALpsTransfCHL] = useState(false); //ALPS transferencia chile
  const [actOxxoMxn, setActOxxoMxn] = useState(false); //oxxo betterbro mexico
  const [actNuveitarjeta, setActNuveitarjeta] = useState(false); //NUVEI
  const [actAstroCH, setActAstroCH] = useState(false);  // astro chile
  const [actAstroARG, setActAstroARG] = useState(false);  // astro argentina
  const [actAstroCO, setActAstroCO] = useState(false);  // astro colombia
  const [actMonnetGTQCash, setActMonnetGTQCash] = useState(false);  // monnet guatemala cash 
  const [actMonnetGTQTransf, setActMonnetGTQTransf] = useState(false);  // monnet guatemala bankTransfer 
  const [actBetterbroPYG, setActBetterbroPYG] = useState(false);  // betterbro paraguay  
  const [actBDV, setActBDV] = useState(false);  // BDV venezuela

  useWrapperDeposit(
    setActRetail,
    //setActAstro,
    setActDeposit,
    setActPagoEfectivo,
    setActTotalP,
    setActTotalPBFC,
    //setActSafeP
    setActMonnetPeru,
    setActMonnetPeruYape,
    setActMonnetChileTarjeta,
    setActMonnetChileBancos,
    setActPFtigomoney,
    setActPFyape,
    setActPFqr,
    setActBinanceDolar,
    setActSpei,
    setActPix,
    setActBinanceBRL,
    setActBinanceOtroMXN,
    setActBinanceOtroARG,
    setActBinanceOtroCOP,
    setActBinanceOtroCLP,
    setActBinanceOtroDOP,
    setActBinanceOtroVES,
    setActBinanceOtroBOB,
    setActBinanceOtroEUR,
    setActCoinspaid,
    setActTotalPBNC,
    setActMibanco,
    setActPFqrbisa,
    setActPFqrMercantil,
    setActALpsPEN,
    setActALpsEfectivoCHL,
    setActALpsTarjetaCHL,
    setActALpsTransfCHL,
    setActKushkiTransPEN,
    setActKushkiEfectPEN,
    setActKushkiCardPEN,
    setActOxxoMxn,
    setActMonnetGTQCash,
    setActMonnetGTQTransf,
    setActAstroCO,
    setActAstroCH,
    setActAstroARG,
    setActBetterbroPYG,
  );

  useEffect( () => {
    const checkCountry = async () => {
      const {data} = await axios.post(API_URL + 'getCountryByPhoneNumber', { id_uo });
      if(data.status===1) {
        if(data.response==='EC') {
          setActAstro(true);
          setActNuvei(true);
          setActMonnetEcuadorBancos(true);
          setActMonnetEcuadorTarjeta(true);
          setActBinanceDolar(true);
          setActCoinspaid(true);
          setActALpsECU(true);
          //setActKushkiTransECU(true);
          //setActKushkiEfectECU(true);
          //setActKushkiCardECU(true);
          //setActDeuna(true);
          //setActNuveitarjeta(true);
        }
      }
    }

    if(moneda==='$') checkCountry();
    //if(moneda==='BOB') setActAstro(true);
    if(moneda ==='BOB') setActDeposit(false);
    if(user.toUpperCase() === 'TEST3') setActSafeP(true);
    if(moneda==='Sol') {
      setActTuPay(true);
    }



    if(moneda ==='GTQ') setActDeposit(false);

    if (user === "test5") {
      setActBDV(true);
    }

    if (user === "r0mul0") {
      setActBDV(true);
    }

  },[])
/*Banca móvil, QR (Yape, Plin) <br/> y Agentes*/

  return (
    <div style={{display: 'flex', flexDirection: 'column'}}>
    <AsideMenu className={selected?'hideView':null}>

      {
        (actTuPay) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('tupayXAQR')}} className={selected==='tupay'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={yape} alt='yape' width='120px' height='37px' style={{marginRight: '-78px'}}/>
               <img src={plim} alt='plim' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              
            </div>
            <div style={{display: 'block', justifyContent: 'space-around', marginTop: '0.35rem',alignItems: 'center'}}>
              <img src={Rtupay} alt='Rtupay' width='170px' height='40px' style={{marginLeft: '75px'}}/>
              <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min S/ 10.00</p>
              </div>
               <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max S/ 20,000.00</p>
              </div>
            </div>
          </div>
        </DepositCard>
      }

      {
        (actKushkiCardPEN) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('KushkiCard')}} className={selected==='KushkiCard'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={visa} alt='visa' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={mastercard} alt='mastercard' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              
            </div>
            <div style={{display: 'block', justifyContent: 'space-around', marginTop: '0.35rem',alignItems: 'center'}}>
              <img src={Rkushki} alt='Rkushki' width='170px' height='40px' style={{marginLeft: '75px'}}/>
              <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min S/ 10.00</p>
              </div>
               <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max S/ 10,000.00</p>
              </div>
            </div>
          </div>
        </DepositCard>
      }

      {
        (actMonnetPeruYape) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('monnetYape')}} className={selected==='monnetYape'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={yape} alt='yape' width='120px' height='37px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rmonnet} alt='Rmonnet' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min S/ 10.00</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max S/ 10,000.00</p>
            </div>
          </div> 
        </DepositCard>
      }

      {
        (actTuPay) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('tupay2')}} className={selected==='tupay2'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={bcp} alt='bcp' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={Bbva} alt='Bbva' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={scotia} alt='scotia' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={interbank} alt='interbank' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={wester} alt='wester' width='120px' height='37px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rtupay} alt='Rtupay' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min S/ 20.00</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max S/ 20,000.00</p>
            </div>
          </div> 
        </DepositCard>
      }

      {
        (actTuPay) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('tupayXACC')}} className={selected==='tupayXACC'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={visa} alt='visa' width='120px' height='37px' style={{marginRight: '-78px'}} />
              <img src={mastercard} alt='mastercard' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              
            </div>
            <div style={{display: 'block', justifyContent: 'space-around', marginTop: '0.35rem',alignItems: 'center'}}>
              <img src={Rtupay} alt='Rtupay' width='170px' height='40px' style={{marginLeft: '75px'}}/>
              <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min S/ 20.00</p>
              </div>
               <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max S/ 20,000.00</p>
              </div>
            </div>
          </div>
        </DepositCard>
      }

      {
        (actKushkiEfectPEN) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('KushkiEfectivo')}} className={selected==='KushkiEfectivo'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={bcpagente} alt='bcpagente' width='60px' height='37px' style={{marginLeft: '45px'}}/>
              <img src={Bbva} alt='Bbva' width='100px' height='37px' style={{marginLeft: '-27px'}}/>
              <img src={niubiz} alt='niubiz' width='60px' height='37px' style={{marginLeft: '-27px'}}/>
              <img src={kasnet} alt='kasnet' width='60px' height='37px' style={{marginLeft: '6px'}}/>
              
            </div>
            <div style={{display: 'block', justifyContent: 'space-around', marginTop: '0.35rem',alignItems: 'center'}}>
              <img src={Rkushki} alt='Rtupay' width='170px' height='40px' style={{marginLeft: '75px'}}/>
              <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min S/ 50.00</p>
              </div>
               <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max S/ 5,000.00</p>
              </div>
            </div>
          </div>
        </DepositCard>
      }

      {
        (actPagoEfectivo) &&
        <DepositCard onClick={()=>{handleActiveDepositMethod('pagoEfectivo')}} className={selected==='pagoEfectivo'?'active':null} >
        {/**actPagoEfectivo */}
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={yape} alt='yape' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={plim} alt='plim' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={bcp} alt='bcp' width='120px' height='37px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={pagoefect} alt='pagoefect' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min S/ 50.00</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max S/ 2,500.00</p>
            </div>
          </div> 
        </DepositCard>
      }

      {
        (actPagoEfectivo) &&
        <DepositCard onClick={()=>{handleActiveDepositMethod('pagoEfectivo2')}} className={selected==='pagoEfectivo2'?'active':null} >
        {/**actPagoEfectivo */}
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={PFprincipal} alt='PFprincipal' width='210px' height='60px' style={{marginRight: '-78px', marginBottom: '-10px', marginTop:'-15px'}}/>
              
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Ragentes} alt='pagoefect' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min S/ 50.00</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max S/ 2,500.00</p>
            </div>
          </div> 
        </DepositCard>
      }

      {
        (actKushkiTransPEN) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('KushkiTransf')}} className={selected==='KushkiTransf'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={yape} alt='yape' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={bcp} alt='bcp' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={interbank} alt='interbank' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={Bbva} alt='bbva' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={scotia} alt='scotia' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              
            </div>
            <div style={{display: 'block', justifyContent: 'space-around', marginTop: '0.35rem',alignItems: 'center'}}>
              <img src={Rkushki} alt='Rtupay' width='170px' height='40px' style={{marginLeft: '75px'}}/>
              <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min S/ 50.00</p>
              </div>
               <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max S/ 5,000.00</p>
              </div>
            </div>
          </div>
        </DepositCard>
      }

  
      {
        (actPix) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('Pix')}} className={selected==='Pix'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={pix} alt='pix' width='120px' height='43px' style={{marginRight: '-78px'}}/> 
            </div>
            <div style={{display: 'block', justifyContent: 'space-around', marginTop: '0px', alignItems: 'center'}}>
              <img src={Rbetterbro} alt='Rtupay' width='170px' height='40px' style={{marginLeft: '75px'}}/>
              <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min BRL 20.00</p>
              </div>
               <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max BRL 20,000.00</p>
              </div>
            </div>
          </div>
        </DepositCard>
      }
      {
        (actRetail) &&
          <DepositCard onClick={()=>{handleActiveDepositMethod('pay4fun')}} className={selected==='pay4fun'?'active':null}>
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
              <div style={{display: 'flex', justifyContent: 'space-around'}}>
                <img src={pix} alt='pix' width='120px' height='37px' style={{marginRight: '-78px'}}/>
                <img src={brasilB} alt='brasilB' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              </div>
              <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
                <img src={payfourfun} alt='payfourfun' width='170px' height='40px' style={{marginLeft: '75px'}}/>
              </div>
              <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min BRL 20.00</p>
              </div>
              <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max BRL 20,000.00</p>
              </div>
            </div> 
          </DepositCard>
      }
      {
        (actRetail) &&
          <DepositCard onClick={()=>{handleActiveDepositMethod('pay4fun2')}} className={selected==='pay4fun2'?'active':null}>
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
              <div style={{display: 'flex', justifyContent: 'space-around'}}>
                <img src={santander} alt='santander' width='120px' height='37px' style={{marginRight: '-78px'}}/>
                <img src={caixa} alt='caixa' width='120px' height='37px' style={{marginRight: '-78px'}}/>
                <img src={bradesco} alt='bradesco' width='120px' height='37px' style={{marginRight: '-78px'}}/>
                <img src={boleto} alt='boleto' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              </div>
              <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
                <img src={payfourfun} alt='payfourfun' width='170px' height='40px' style={{marginLeft: '75px'}}/>
              </div>
              <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min BRL 20.00</p>
              </div>
              <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max BRL 20,000.00</p>
              </div>
            </div>
          </DepositCard>
      }

        <>{/*actTotalP*/}</>

      {
        (actMiBanco) &&
        <DepositCard onClick={()=>{handleActiveDepositMethod('MiBanco')}} className={selected==='MiBanco'?'active':null}>
        {/* Estrella y texto en la esquina superior derecha */}
          <div style={{ 
            position: 'absolute', 
            marginLeft: '165px', 
            marginTop: '-100px', 
            display: 'flex', 
            alignItems: 'center', 
            backgroundColor: '#30AD19', 
            padding: '2.5px', 
            borderRadius: '9px', 
            border: '1px solid gold', 
            fontSize: '9px', 
            color: 'white', 
            fontWeight: 'bold',
            fontFamily: 'sans-serif'
          }}>
            <img src={star} alt="star" width="12px" height="12px" style={{ marginRight: '2px', marginTop: '-2.5px' }} />
            
            {/* Contenedor para los textos "Nuevo" y "Automático" */}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <p style={{ margin: 0 }}>Nuevo</p>
              <p style={{ margin: 0 }}>Automático</p>
            </div>
          </div>

          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.5rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={pagomovil} alt='r4venezuela' width='135px' height='37px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0px', alignItems: 'center'}}>
              <img src={RMibank} alt='RMibank' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min 10 VES</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 100.000 VES</p>
            </div>
          </div>
        </DepositCard>
      }

      {
        (actBDV) &&
        <DepositCard onClick={()=>{handleActiveDepositMethod('bdv')}} className={selected==='bdv'?'active':null}>
        {/* Estrella y texto en la esquina superior derecha */}
          <div style={{ 
            position: 'absolute', 
            marginLeft: '165px', 
            marginTop: '-100px', 
            display: 'flex', 
            alignItems: 'center', 
            backgroundColor: '#30AD19', 
            padding: '2.5px', 
            borderRadius: '9px', 
            border: '1px solid gold', 
            fontSize: '9px', 
            color: 'white', 
            fontWeight: 'bold',
            fontFamily: 'sans-serif'
          }}>
            <img src={star} alt="star" width="12px" height="12px" style={{ marginRight: '2px', marginTop: '-2.5px' }} />
            
            {/* Contenedor para los textos "Nuevo" y "Automático" */}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <p style={{ margin: 0 }}>Nuevo</p>
              <p style={{ margin: 0 }}>Automático</p>
            </div>
          </div>

          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.5rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={pagomovil} alt='r4venezuela' width='135px' height='37px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0px', alignItems: 'center'}}>
              <img src={Rebdv} alt='Rebdv' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min 10 VES</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 100.000 VES</p>
            </div>
          </div>
        </DepositCard>
      }

      {
        (actTotalPBNC) &&
        <DepositCard onClick={()=>{handleActiveDepositMethod('totalPagoBNC')}} className={selected==='totalPagoBNC'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={BNC} alt='bfc' width='120px' height='37px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rtotalpago} alt='payfourfun' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min 10 VES</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 200.000 VES</p>
            </div>
          </div>
        </DepositCard>
      }

      {
        (actTotalP) &&
        <DepositCard onClick={()=>{handleActiveDepositMethod('totalPago')}} className={selected==='totalPago'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={bdv} alt='bdv' width='120px' height='37px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rtotalpago} alt='payfourfun' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min 10 VES</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 200.000 VES</p>
            </div>
          </div>
        </DepositCard>
      }
      {
        (actTotalPBFC) &&
        <DepositCard onClick={()=>{handleActiveDepositMethod('totalPagoBFC')}} className={selected==='totalPagoBFC'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={bfc} alt='bfc' width='120px' height='37px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rtotalpago} alt='payfourfun' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min 10 VES</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 200.000 VES</p>
            </div>
          </div>
        </DepositCard>
      }

      {
        (actSafeP) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('safetyPay')}} className={selected==='safetyPay'?'active':null}>
          <div style={{display: 'flex', alignItems: 'center', marginTop: '0.35rem'}}>
            <img src={logoSafetyPay} alt='logo SafetyPay' width='120px' height='40px' />
            <div style={{marginLeft: '0.55rem'}}><span style={{fontWeight:'bold', color: '#000000'}}>Safety Pay</span></div>
          </div>
        </DepositCard>
      }

      {
        (actDeuna) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('Deuna')}} className={selected==='Deuna'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '-15px', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={deuna} alt='deuna' width='120px' height='70px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '-0.50rem', alignItems: 'center'}}>
              <img src={Rnuvei} alt='Rnuvei' width='170px' height='32px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min $1.00</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max $1,000.00</p>
            </div>
          </div>
          
        </DepositCard>
      }

      {
        (actAstro) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('astropay')}} className={selected==='astropay'?'active':null}>
         <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={pichincha} alt='pichincha' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={guayaquil} alt='guayaquil' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={facilito} alt='facilito' width='120px' height='37px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rastro} alt='astropay' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold'}}> Min $1.00</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max $20,000.00</p>
            </div>
          </div>
              
        </DepositCard>
      }
      {
        (actNuveitarjeta) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('nuvei')}} className={selected==='nuvei'?'active':null}>
         <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={visa} alt='visa' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={mastercard} alt='mastercard' width='120px' height='37px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rnuvei} alt='Rnuvei' width='170px' height='32px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min $10.00</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max $20,000.00</p>
            </div>
          </div>
          
        </DepositCard>
      }
      {
        (actNuvei) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('nuvei2')}} className={selected==='nuvei2'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={otros} alt='pichincha' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={guayaquil} alt='guayaquil' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={facilito} alt='facilito' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={amazonas} alt='amazonas' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rnuvei} alt='Rnuvei' width='170px' height='32px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min $10.00</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max $20,000.00</p>
            </div>
          </div>
          
        </DepositCard>
      }
      {
        (actNuvei) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('nuvei3')}} className={selected==='nuvei3'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={Bbarrio} alt='Bbarrio' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={facilito} alt='facilito' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={wester} alt='wester' width='120px' height='37px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rnuvei} alt='Rnuvei' width='170px' height='32px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min $10.00</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max $20,000.00</p>
            </div>
          </div>
          
        </DepositCard>
      }

      {
        (actAlpsTarjetaCHL) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('AlpsTarjetaChile')}} className={selected==='AlpsTarjetaChile'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={webpay} alt='webpay' width='120px' height='37px' style={{marginRight: '-78px' ,  marginLeft: '45px'}}/>
              <img src={visa} alt='visa' width='120px' height='37px' style={{marginRight: '-78px' , marginLeft: '50px'}}/>
              <img src={mastercard} alt='mastercard' width='120px' height='37px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Ralps} alt='Ralps' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 1,000 CLP</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 10,000,000 CLP</p>
            </div>
          </div> 
        </DepositCard>
      }

      {
        (actAlpsEfectivoCHL) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('AlpsEfectivoChile')}} className={selected==='AlpsEfectivoChile'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={lider} alt='lider' width='70px' height='37px' style={{marginRight: '-40px', marginLeft: '2px'}}/>
              <img src={express} alt='express' width='70px' height='37px' style={{marginRight: '-60px', marginLeft: '50px'}}/>
              <img src={acuenta} alt='acuenta' width='70px' height='37px' style={{marginRight: '-78px', marginLeft: '70px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Ralps} alt='Ralps' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 1,000 CLP</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 10,000,000 CLP</p>
            </div>
          </div> 
        </DepositCard>
      }

      {
        (actAstroCH) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('astropayCH')}} className={selected==='astropayCH'?'active':null}>
         <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={visa} alt='visa' width='120px' height='37px' style={{marginRight: '-80px', marginLeft: '-4px'}}/>
              <img src={mastercard} alt='mastercard  ' width='120px' height='37px' style={{marginRight: '-80px'}}/>
              <img src={BEstado} alt='BEstado' width='120px' height='37px' style={{marginRight: '-80px'}}/>
              <img src={BChile} alt='BChile' width='120px' height='37px' style={{marginRight: '-80px'}}/>
              <img src={BFalabella} alt='BFalabella' width='120px' height='37px' style={{marginRight: '-80px'}}/>
              <img src={itau} alt='itau' width='120px' height='37px' style={{marginRight: '-80px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rastro} alt='astropay' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold'}}>Min 5,000 CLP</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 10,000,000 CLP</p>
            </div>
          </div>
              
        </DepositCard>
      }

      {
        (actAlpsTransfCHL) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('AlpsTransfChile')}} className={selected==='AlpsTransfChile'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={BEstado} alt='BEstado' width='120px' height='37px' style={{marginRight: '-80px', marginLeft: '-35px'}}/>
              <img src={scotia} alt='scotia' width='120px' height='37px' style={{marginRight: '-80px'}}/>
              <img src={BChile} alt='BChile' width='120px' height='37px' style={{marginRight: '-80px'}}/>
              <img src={santander} alt='santander' width='120px' height='37px' style={{marginRight: '-70px'}}/>
              <img src={BFalabella} alt='BFalabella' width='120px' height='37px' style={{marginRight: '-60px' , marginLeft: '-10px'}}/>
              <img src={mach} alt='mach' width='40px' height='37px' style={{marginRight: '-72px', marginLeft: '20px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Ralps} alt='Ralps' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 10,000 CLP</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 10,000,000 CLP</p>
            </div>
          </div> 
        </DepositCard>
      }

      {
        (actMonnetChileTarjeta) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('monnetTarjeta')}} className={selected==='monnetTarjeta'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={visa} alt='visa' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={mastercard} alt='mastercard' width='120px' height='37px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rmonnet} alt='Rmonnet' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min 3,000 CLP</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 10,000,000 CLP</p>
            </div>
          </div> 
        </DepositCard>
      }
      {
        (actMonnetChileBancos) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('monnetBancosCH')}} className={selected==='monnetBancosCH'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={BEstado} alt='BEstado' width='120px' height='37px' style={{marginRight: '-80px', marginLeft: '-4px'}}/>
              <img src={scotia} alt='scotia' width='120px' height='37px' style={{marginRight: '-80px'}}/>
              <img src={BChile} alt='BChile' width='120px' height='37px' style={{marginRight: '-80px'}}/>
              <img src={santander} alt='santander' width='120px' height='37px' style={{marginRight: '-80px'}}/>
              <img src={BFalabella} alt='BFalabella' width='120px' height='37px' style={{marginRight: '-80px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rmonnet} alt='Rmonnet' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min 10,000 CLP</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 10,000,000 CLP</p>
            </div>
          </div> 
        </DepositCard>
      }
      {
        (actMonnetPeru) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('monnet')}} className={selected==='monnet'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={visa} alt='visa' width='120px' height='37px' style={{marginRight: '-80px', marginLeft: '-4px'}}/>
              <img src={mastercard} alt='mastercard' width='120px' height='37px' style={{marginRight: '-80px'}}/>
              <img src={bcp} alt='bcp' width='120px' height='37px' style={{marginRight: '-80px'}}/>
              <img src={interbank} alt='interbank' width='120px' height='37px' style={{marginRight: '-80px'}}/>
              <img src={Bbva} alt='Bbva' width='120px' height='37px' style={{marginRight: '-80px'}}/>
              <img src={ripley} alt='ripley' width='120px' height='37px' style={{marginRight: '-80px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rmonnet} alt='Rmonnet' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min S/ 100.00</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max S/ 10,000.00</p>
            </div>
          </div> 
        </DepositCard>
      }
      {
        (actMonnetEcuadorTarjeta) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('monnetTarjetaEcu')}} className={selected==='monnetTarjetaEcu'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={visa} alt='visa' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={mastercard} alt='mastercard' width='120px' height='37px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rmonnet} alt='Rmonnet' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min $5.00</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max $50.00</p>
            </div>
          </div> 
        </DepositCard>
      }
      {
        (actMonnetEcuadorBancos) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('monnetBancos')}} className={selected==='monnetBancos'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={pichincha} alt='pichincha' width='120px' height='37px' style={{marginRight: '-80px', marginLeft: '-4px'}}/>
              <img src={guayaquil} alt='guayaquil' width='120px' height='37px' style={{marginRight: '-80px'}}/>
              <img src={Bbarrio} alt='Bbarrio' width='120px' height='37px' style={{marginRight: '-80px'}}/>
              <img src={facilito} alt='facilito' width='120px' height='37px' style={{marginRight: '-80px'}}/>
              <img src={redactiva} alt='redactiva' width='120px' height='37px' style={{marginRight: '-80px'}}/>
              
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rmonnet} alt='Rmonnet' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min $20.00</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max $5,000.00</p>
            </div>
          </div> 
        </DepositCard>
      }
      {
        (actPFtigomoney) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('PFtigomoney')}} className={selected==='PFtigomoney'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={tigomoney} alt='tigomoney' width='120px' height='37px' style={{marginRight: '-78px', marginTop: '20px'}}/>
              
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.20rem', alignItems: 'center'}}>
              <img src={Rpagofacil} alt='Rpagofacil' width='170px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min 10.00 BOB</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 5,000 BOB</p>
            </div>
          </div> 
        </DepositCard>
      }
      {
        (actPFyape) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('PFyape')}} className={selected==='PFyape'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px',  marginTop: '20px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={yape2} alt='soli' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rpagofacil} alt='Rpagofacil' width='170px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min 10.00 BOB</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 5,000 BOB</p>
            </div>
          </div> 
        </DepositCard>
      }
      {
        (actPFqr) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('PFqr')}} className={selected==='PFqr'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px',  marginTop: '20px'}}>
             <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold', marginTop: '-15px', marginBottom:'10px'}}> Pago con QR</p>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={logoqr} alt='qr' width='120px' height='45px' style={{marginRight: '-78px'}}/>
              
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', alignItems: 'center', marginTop: '-10px'}}>
              <img src={Rpagofacil} alt='Rpagofacil' width='170px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min 10.00 BOB</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 10,000 BOB</p>
            </div>
          </div> 
        </DepositCard>
      }

      {
        (actPFqrbisa) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('PFqrbisa')}} className={selected==='PFqrbisa'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px',  marginTop: '20px'}}>
             <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold', marginTop: '-15px', marginBottom:'10px'}}> Pago con QR</p>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={logoqr} alt='qr' width='120px' height='45px' style={{marginRight: '-78px'}}/>
              
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', alignItems: 'center', marginTop: '-10px'}}>
              <img src={Rpagofacil} alt='Rpagofacil' width='170px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min 10.00 BOB</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 10,000 BOB</p>
            </div>
          </div> 
        </DepositCard>
      }

      {
        (actPFqrMercantil) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('PFqrMercantil')}} className={selected==='PFqrMercantil'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px',  marginTop: '20px'}}>
             <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold', marginTop: '-15px', marginBottom:'10px'}}> Pago con QR</p>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={logoqr} alt='qr' width='120px' height='45px' style={{marginRight: '-78px'}}/>
              
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', alignItems: 'center', marginTop: '-10px'}}>
              <img src={Rpagofacil} alt='Rpagofacil' width='170px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min 10.00 BOB</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 10,000 BOB</p>
            </div>
          </div> 
        </DepositCard>
      }

      {
        (actAstroCO) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('astropayCO')}} className={selected==='astropayCO'?'active':null}>
         <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={Bcolombia} alt='Bcolombia' width='60px' height='37px' style={{marginRight: '3px', marginLeft: '31px'}}/>
              <img src={efecty} alt='efecty  ' width='60px' height='37px' style={{marginRight: '3px'}}/>
              <img src={daviplata} alt='daviplata' width='60px' height='37px' style={{marginRight: '3px'}}/>
              <img src={nequi} alt='nequi' width='60px' height='37px' style={{marginRight: '-40px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rastro} alt='astropay' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold'}}>Min 5,000 COP</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 5,000,000 COP</p>
            </div>
          </div>
              
        </DepositCard>
      }

      {
        (actPayRetailer) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('payretailer')}} className={selected==='payretailer'?'active':null}>
          <div style={{display: 'flex', alignItems: 'center', marginTop: '0.35rem'}}>
            <img src={payretailerLogo} alt='logo payretailer' width='120px' height='40px' />
            <div style={{marginLeft: '0.55rem'}}><span style={{fontWeight:'bold', color: '#000000'}}>PayRetailers</span></div>
          </div> 
        </DepositCard>
      }

      {
        (actSpei) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('Spei')}} className={selected==='Spei'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px',  marginTop: '0px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={spei} alt='spei' width='120px' height='37px' style={{marginRight: '-78px'}}/> 
            </div>
            <div style={{display: 'block', justifyContent: 'space-around', marginTop: '0.35rem',alignItems: 'center'}}>
              <img src={Rbetterbro} alt='Rtupay' width='170px' height='40px' style={{marginLeft: '75px'}}/>
              <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 30.00 MXN</p>
              </div>
               <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 100,000 MXN</p>
              </div>
            </div>
          </div>
        </DepositCard>
      }

      {
        (actOxxoMxn) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('oxxo')}} className={selected==='oxxo'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={oxxo} alt='oxxo' width='75px' height='43px' style={{marginRight: '-78px'}}/> 
            </div>
            <div style={{display: 'block', justifyContent: 'space-around', marginTop: '0px', alignItems: 'center'}}>
              <img src={Rbetterbro} alt='Rtupay' width='170px' height='40px' style={{marginLeft: '75px'}}/>
              <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 100.00 MXN</p>
              </div>
               <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 50,000 MXN</p>
              </div>
            </div>
          </div>
        </DepositCard>
      }

      {
        (actAlpsECU) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('Alps')}} className={selected==='Alps'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={pichincha} alt='pichincha' width='120px' height='37px' style={{marginRight: '-80px', marginLeft: '-4px'}}/>
              <img src={guayaquil} alt='guayaquil' width='120px' height='37px' style={{marginRight: '-80px'}}/>
              <img src={Bbarrio} alt='Bbarrio' width='120px' height='37px' style={{marginRight: '-80px'}}/>
              <img src={facilito} alt='facilito' width='120px' height='37px' style={{marginRight: '-80px'}}/>
              <img src={redactiva} alt='redactiva' width='120px' height='37px' style={{marginRight: '-80px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Ralps} alt='Ralps' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min $20.00</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max $5,000.00</p>
            </div>
          </div> 
        </DepositCard>
      }

      {
        (actBinanceDolar) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('BinanceOtro')}} className={selected==='Binancepay'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={usdt} alt='usdt' width='140px' height='35px' style={{marginRight: '-78px'}}/> 
            </div>
            <div style={{display: 'block', justifyContent: 'space-around', marginTop: '0.35rem',alignItems: 'center'}}>
              <img src={Rbetterbro} alt='Rtupay' width='170px' height='40px' style={{marginLeft: '75px'}}/>
              <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min $1.00</p>
              </div>
               <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max $20,000.00</p>
              </div>
            </div>
          </div>
        </DepositCard>
      }

      {
        (actBinanceBRL) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('BinanceOtro')}} className={selected==='BinanceOtro'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={usdt} alt='usdt' width='140px' height='35px' style={{marginRight: '-78px'}}/> 
            </div>
            <div style={{display: 'block', justifyContent: 'space-around', marginTop: '0.35rem',alignItems: 'center'}}>
              <img src={Rbetterbro} alt='Rtupay' width='170px' height='40px' style={{marginLeft: '75px'}}/>
              <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min BRL 10.00</p>
              </div>
               <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max BRL 100,000.00</p>
              </div>
            </div>
          </div>
        </DepositCard>
      }

      {
        (actBinanceOtroMXN) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('BinanceOtro')}} className={selected==='BinanceOtro'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={usdt} alt='usdt' width='140px' height='35px' style={{marginRight: '-78px'}}/> 
            </div>
            <div style={{display: 'block', justifyContent: 'space-around', marginTop: '0.35rem',alignItems: 'center'}}>
              <img src={Rbetterbro} alt='Rtupay' width='170px' height='40px' style={{marginLeft: '75px'}}/>
              <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 20.00 MXN</p>
              </div>
               <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 200,000 MXN</p>
              </div>
            </div>
          </div>
        </DepositCard>
      }

      {
        (actAstroARG) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('astropayARG')}} className={selected==='astropayARG'?'active':null}>
         <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
             <img src={visa} alt='visa' width='120px' height='37px' style={{marginRight: '-80px', marginLeft: '-1px'}}/>
              <img src={mastercard} alt='mastercard' width='120px' height='37px' style={{marginRight: '-80px'}}/>
              <img src={Bbva} alt='Bbva' width='120px' height='37px' style={{marginRight: '-40px'}}/>
              <img src={rapipago} alt='rapipago' width='60px' height='37px' style={{marginRight: '2px'}}/>
              <img src={qrars} alt='qrars' width='60px' height='37px'/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rastro} alt='astropay' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold'}}>Min 1,000 ARS</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 1,000,000 ARS</p>
            </div>
          </div>
              
        </DepositCard>
      }

      {
        (actBinanceOtroARG) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('BinanceOtro')}} className={selected==='BinanceOtro'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={usdt} alt='usdt' width='140px' height='35px' style={{marginRight: '-78px'}}/> 
            </div>
            <div style={{display: 'block', justifyContent: 'space-around', marginTop: '0.35rem',alignItems: 'center'}}>
              <img src={Rbetterbro} alt='Rtupay' width='170px' height='40px' style={{marginLeft: '75px'}}/>
              <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 2,000 ARS</p>
              </div>
               <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 20,000,000 ARS</p>
              </div>
            </div>
          </div>
        </DepositCard>
      }

      {
        (actBinanceOtroCOP) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('BinanceOtro')}} className={selected==='BinanceOtro'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={usdt} alt='usdt' width='140px' height='35px' style={{marginRight: '-78px'}}/> 
            </div>
            <div style={{display: 'block', justifyContent: 'space-around', marginTop: '0.35rem',alignItems: 'center'}}>
              <img src={Rbetterbro} alt='Rtupay' width='170px' height='40px' style={{marginLeft: '75px'}}/>
              <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 5,000 COP</p>
              </div>
               <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 50,000,000 COP</p>
              </div>
            </div>
          </div>
        </DepositCard>
      }

      {
        (actBinanceOtroCLP) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('BinanceOtro')}} className={selected==='BinanceOtro'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={usdt} alt='usdt' width='140px' height='35px' style={{marginRight: '-78px'}}/> 
            </div>
            <div style={{display: 'block', justifyContent: 'space-around', marginTop: '0.35rem',alignItems: 'center'}}>
              <img src={Rbetterbro} alt='Rtupay' width='170px' height='40px' style={{marginLeft: '75px'}}/>
              <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 2,000 CLP</p>
              </div>
               <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 20,000,000 CLP</p>
              </div>
            </div>
          </div>
        </DepositCard>
      }

      {
        (actBinanceOtroDOP) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('BinanceOtro')}} className={selected==='BinanceOtro'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={usdt} alt='usdt' width='140px' height='35px' style={{marginRight: '-78px'}}/> 
            </div>
            <div style={{display: 'block', justifyContent: 'space-around', marginTop: '0.35rem',alignItems: 'center'}}>
              <img src={Rbetterbro} alt='Rtupay' width='170px' height='40px' style={{marginLeft: '75px'}}/>
              <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 500.00 DOP</p>
              </div>
               <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 5,000,000 DOP</p>
              </div>
            </div>
          </div>
        </DepositCard>
      }

      {
        (actBinanceOtroVES) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('BinanceOtro')}} className={selected==='BinanceOtro'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={usdt} alt='usdt' width='140px' height='35px' style={{marginRight: '-78px'}}/> 
            </div>
            <div style={{display: 'block', justifyContent: 'space-around', marginTop: '0.35rem',alignItems: 'center'}}>
              <img src={Rbetterbro} alt='Rtupay' width='170px' height='40px' style={{marginLeft: '75px'}}/>
              <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 40 VES</p>
              </div>
               <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 500.000 VES</p>
              </div>
            </div>
          </div>
        </DepositCard>
      }

      {
        (actBinanceOtroBOB) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('BinanceOtro')}} className={selected==='BinanceOtro'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={usdt} alt='usdt' width='140px' height='35px' style={{marginRight: '-78px'}}/> 
            </div>
            <div style={{display: 'block', justifyContent: 'space-around', marginTop: '0.35rem',alignItems: 'center'}}>
              <img src={Rbetterbro} alt='Rtupay' width='170px' height='40px' style={{marginLeft: '75px'}}/>
              <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 10.00 BOB</p>
              </div>
               <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 100,000 BOB</p>
              </div>
            </div>
          </div>
        </DepositCard>
      }

      {
        (actBinanceOtroEUR) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('BinanceOtro')}} className={selected==='BinanceOtro'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={usdt} alt='usdt' width='140px' height='35px' style={{marginRight: '-78px'}}/> 
            </div>
            <div style={{display: 'block', justifyContent: 'space-around', marginTop: '0.35rem',alignItems: 'center'}}>
              <img src={Rbetterbro} alt='Rtupay' width='170px' height='40px' style={{marginLeft: '75px'}}/>
              <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 1.00 EUR</p>
              </div>
               <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 20,000 EUR</p>
              </div>
            </div>
          </div>
        </DepositCard>
      }

      {
        (actCoinspaid) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('Coinspaid')}} className={selected==='Coinspaid'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={coinspaid} alt='coinspaid' width='120px' height='40px' style={{marginRight: '-62px'}}/> 
              <img src={btc} alt='btc' width='120px' height='40px' style={{marginRight: '-78px'}}/> 
              <img src={tether} alt='tether' width='120px' height='40px' style={{marginRight: '-78px'}}/> 
            </div>
            <div style={{display: 'block', justifyContent: 'space-around', marginTop: '0.35rem',alignItems: 'center'}}>
              <img src={Rcoinspaid} alt='Rtupay' width='170px' height='40px' style={{marginLeft: '75px'}}/>
              <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> </p>
              </div>
               <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}></p>
              </div>
            </div>
          </div>
        </DepositCard>
      }
      
      {
        (actBetterArs) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('Betterarg')}} className={selected==='Betterarg'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px',  marginTop: '0px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={galicia} alt='galicia' width='120px' height='37px' style={{marginRight: '-78px'}}/> 
              <img src={santander} alt='santander' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={Bbva} alt='Bbva' width='120px' height='37px' style={{marginRight: '-78px'}}/> 
              <img src={nacion} alt='nacion' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={city} alt='city' width='120px' height='37px' style={{marginRight: '-78px'}}/>   
            </div>
            <div style={{display: 'block', justifyContent: 'space-around', marginTop: '0.35rem',alignItems: 'center'}}>
              <img src={Rbetterbro} alt='Rtupay' width='170px' height='40px' style={{marginLeft: '75px'}}/>
              <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 1,000 ARS</p>
              </div>
               <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 5,000,000 ARS</p>
              </div>
            </div>
          </div>
        </DepositCard>
      }

      {
        (actBoleto) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('Boleto')}} className={selected==='Boleto'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px',  marginTop: '0px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={boleto} alt='boleto' width='120px' height='37px' style={{marginRight: '-78px'}}/> 
            </div>
            <div style={{display: 'block', justifyContent: 'space-around', marginTop: '0.35rem',alignItems: 'center'}}>
              <img src={Rbetterbro} alt='Rtupay' width='170px' height='40px' style={{marginLeft: '75px'}}/>
              <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min BRL 50.00</p>
              </div>
               <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max BRL 10,000</p>
              </div>
            </div>
          </div>
        </DepositCard>
      }

      {
        (actAlpsPEN) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('Alps')}} className={selected==='Alps'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={visa} alt='visa' width='120px' height='37px' style={{marginRight: '-80px', marginLeft: '-4px'}}/>
              <img src={mastercard} alt='mastercard' width='120px' height='37px' style={{marginRight: '-80px'}}/>
              <img src={bcp} alt='bcp' width='120px' height='37px' style={{marginRight: '-80px'}}/>
              <img src={interbank} alt='interbank' width='120px' height='37px' style={{marginRight: '-80px'}}/>
              <img src={Bbva} alt='Bbva' width='120px' height='37px' style={{marginRight: '-80px'}}/>
              <img src={ripley} alt='ripley' width='120px' height='37px' style={{marginRight: '-80px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Ralps} alt='Ralps' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min S/ 100.00</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max S/ 10,000.00</p>
            </div>
          </div> 
        </DepositCard>
      }

      {
        (actKushkiCardECU) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('KushkiCard')}} className={selected==='KushkiCard'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={visa} alt='visa' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={mastercard} alt='mastercard' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              
            </div>
            <div style={{display: 'block', justifyContent: 'space-around', marginTop: '0.35rem',alignItems: 'center'}}>
              <img src={Rkushki} alt='Rkushki' width='170px' height='40px' style={{marginLeft: '75px'}}/>
              <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min $5.00</p>
              </div>
               <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max $2,000.00</p>
              </div>
            </div>
          </div>
        </DepositCard>
      }

      {
        (actKushkiTransECU) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('KushkiTransf')}} className={selected==='KushkiTransf'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={pichincha} alt='pichincha' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={guayaquil} alt='guayaquil' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={Bbarrio} alt='Bbarrio' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={facilito} alt='facilito' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={redactiva} alt='redactiva' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              
            </div>
            <div style={{display: 'block', justifyContent: 'space-around', marginTop: '0.35rem',alignItems: 'center'}}>
              <img src={Rkushki} alt='Rtupay' width='170px' height='40px' style={{marginLeft: '75px'}}/>
              <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min $20.00</p>
              </div>
               <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max $5,000.00</p>
              </div>
            </div>
          </div>
        </DepositCard>
      }

      {
        (actKushkiEfectECU) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('KushkiEfectivo')}} className={selected==='KushkiEfectivo'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={Bbarrio} alt='Bbarrio' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={redactiva} alt='redactiva' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={mivecino} alt='mivecino' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={facilito} alt='facilito' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              <img src={wester} alt='wester' width='120px' height='37px' style={{marginRight: '-78px'}}/>
              
            </div>
            <div style={{display: 'block', justifyContent: 'space-around', marginTop: '0.35rem',alignItems: 'center'}}>
              <img src={Rkushki} alt='Rtupay' width='170px' height='40px' style={{marginLeft: '75px'}}/>
              <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min $20.00</p>
              </div>
               <div>
                <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max $5,000.00</p>
              </div>
            </div>
          </div>
        </DepositCard>
      }

      {
        (actMonnetGTQCash) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('monnetGtqCash')}} className={selected==='monnetGtqCash'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={continental} alt='continental' width='55px' height='37px' style={{marginRight: '-25px' ,  marginLeft: '40px'}}/>
              <img src={bam} alt='bam' width='55px' height='37px' style={{marginRight: '-10px' , marginLeft: '32px'}}/>
              <img src={cajadesarrollo} alt='cajadesarrollo' width='55px' height='37px' style={{marginRight: '-40px', marginLeft: '17px'}}/>
              <img src={fundaciongenesis} alt='fundaciongenesis' width='55px' height='37px' style={{marginRight: '-40px',  marginLeft: '45px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rmonnet} alt='Rmonnet' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 100.00 GTQ</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 20,000.00 GTQ</p>
            </div>
          </div> 
        </DepositCard>
      }

      {
        (actMonnetGTQTransf) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('monnetGtqTransf')}} className={selected==='monnetGtqTransf'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={continental} alt='continental' width='120px' height='37px' style={{marginRight: '-50px', marginLeft: '-5px'}}/>
              <img src={bam} alt='bam' width='120px' height='37px' style={{marginRight: '-78px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rmonnet} alt='Rmonnet' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}> Min 100.00 GTQ</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 20,000.00 GTQ</p>
            </div>
          </div> 
        </DepositCard>
      }

      {
        (actBetterbroPYG) &&

        <DepositCard onClick={()=>{handleActiveDepositMethod('betterbroTransPYG')}} className={selected==='betterbroTransPYG'?'active':null}>
          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '0.35rem', marginLeft: '-45px'}}>
            <div style={{display: 'flex', justifyContent: 'space-around'}}>
              <img src={familiarPYG} alt='familiarPYG' width='55px' height='37px' style={{marginRight: '-25px' ,  marginLeft: '36px'}}/>
              <img src={atlasPYG} alt='atlasPYG' width='55px' height='37px' style={{marginRight: '-10px' , marginLeft: '30px'}}/>
              <img src={continentalPYG} alt='continentalPYG' width='55px' height='37px' style={{marginRight: '-40px', marginLeft: '15px'}}/>
              <img src={visionPYG} alt='visionPYG' width='55px' height='37px' style={{marginRight: '-40px',  marginLeft: '45px'}}/>
            </div>
            <div style={{display: 'flex', justifyContent: 'space-around', marginTop: '0.35rem', alignItems: 'center'}}>
              <img src={Rbetterbro} alt='Rbetterbro' width='170px' height='40px' style={{marginLeft: '75px'}}/>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Min 10,000.00 PYG</p>
            </div>
            <div>
              <p style={{ fontSize: '12px', textAlign: 'center', marginLeft: '75px', fontFamily: 'sans-serif', color: '#000', fontWeight: 'bold' }}>Max 50,000,000 PYG</p>
            </div>
          </div> 
        </DepositCard>
      }
         
      {
        (actDeposit) &&
          <DepositCard onClick={()=>{handleActiveDepositMethod('deposit')}} className={selected==='deposit'?'active':null}>
          <div style={{display: 'flex', alignItems: 'center', marginTop: '0.35rem'}}>
          <img
            src={transferenciaLogo}
            alt="log"
            width="120px"
            height="37px"
          />
          <div style={{marginLeft: '0.55rem'}}><span style={{fontWeight:'bold', color: '#000000'}}>{t("deposit.direct-transfer")}</span></div>
          </div>
        </DepositCard>      
      }

    </AsideMenu>

        <DepositTerms className={selected ? 'hideView deposit' : "deposit"}>
          <span style={{ textAlign: "justify", display: "block", margin: "0 auto" }}>
            Una vez validada su cuenta de usuario e identidad, todos los jugadores tendrán acceso a los diversos <strong>canales de recarga disponibles</strong> en el País o Región. Estos procesos <strong>no tienen ningún costo.</strong> Si tiene alguna consulta o si su recarga <strong>no se ha reflejado correctamente en su saldo</strong>, le invitamos a utilizar nuestro chat en vivo para ser asistido por uno de nuestros asesores.
          </span>
        </DepositTerms>
    </div>

  );
};

export default FormWrapper;